import React, { memo } from "react";

interface Props {
  [otherProps: string]: any;
}

const AppAwayHoursForm: React.FC<Props> = ({
  ...otherProps
}) => {
  return <React.Fragment>AppAwayHoursForm</React.Fragment>;
};

export default memo(AppAwayHoursForm);
